import { render, staticRenderFns } from "./selfInputPolicyNumber.vue?vue&type=template&id=1fa79e0f"
import script from "./selfInputPolicyNumber.vue?vue&type=script&lang=js"
export * from "./selfInputPolicyNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports